import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivityHistory, Capa, CapaPic } from './audit.model';
import { API_URL } from '../app.constants';
import { RequestResult, TableData } from '../shared/shared.model';
import { map } from 'rxjs/operators';

@Injectable()
export class CapaService {
  getActivities(capaId: number, page: number = 0, pageSize: number = 10): Observable<TableData<ActivityHistory>> {
    return this.http.get<TableData<Capa>>(`${API_URL}/Capas/${capaId}/activities`, {
      params: {
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<ActivityHistory>) => {
        res.page--;

        return res;
      })
    );  }

  constructor(
    private http: HttpClient
  ) { }

  getCapa(id: number | string): Observable<Capa> {
    return this.http.get<Capa>(`${API_URL}/Capas/${id}`);
  }

  getCapaList(findingId: number = 0, page: number = 0, pageSize: number = 10, searchKeyword = ''): Observable<TableData<Capa>> {
    let findingIdUrl = '';
    if (findingId > 0) {
      findingIdUrl = `/byFinding/${findingId}`;
    }

    return this.http.get<TableData<Capa>>(`${API_URL}/Capas${findingIdUrl}`, {
      params: {
        SearchKeyword: searchKeyword,
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<Capa>) => {
        res.page--;

        return res;
      })
    );
  }

  getCapaListHistory(page: number = 0, pageSize: number = 10, id : number = 0): Observable<TableData<Capa>> {    

    return this.http.get<TableData<Capa>>(`${API_URL}/Capas/history/${id}`, {
      params: {       
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<Capa>) => {
        res.page--;

        return res;
      })
    );
  }

  public getCapaListBySid(sidId: number = 0, page: number = 0, pageSize: number = 10, searchKeyword = ''): Observable<TableData<Capa>> {
    let sidUrl = '';
    if (sidId > 0) {
      sidUrl = `/bySid/${sidId}`;
    }

    return this.http.get<TableData<Capa>>(`${API_URL}/Capas${sidUrl}`, {
      params: {
        SearchKeyword: searchKeyword,
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<Capa>) => {
        res.page--;

        return res;
      })
    );
  }
  submitCapa(capa: Capa) : Observable<number> {
    return this.http.post<number>(`${API_URL}/Capas`, capa);
  }
  submitEvidences(id: number): Observable<number> {
    return this.http.get<number>(`${API_URL}/Capas/${id}/submit`);
  }
  getPics() : Observable<Array<CapaPic>> {
    return this.http.get<Array<CapaPic>>(`${API_URL}/CapaPics`);
  }
  deleteCapa(id: number): Observable<RequestResult> {
    return this.http.delete<RequestResult>(`${API_URL}/Capas/${id}`);
  }
  checkCapaExistence(id: number, title: any): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/Capas/exists/${id}/${encodeURI(title)}`);
  }
  checkCapaSidExistence(id: number, title: any): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/Capas/exists/sid/${id}/${encodeURI(title)}`);
  }
  updateCapa(capa: Capa): Observable<Capa> {
    return this.http.patch<Capa>(`${API_URL}/capas/${capa.id}`, capa);
  }
}
